<template>
  <div class="textConfirmed">
    <van-sticky>
      <div class="textHeader">
        <van-icon name="arrow-left" color="#777" class="vanIconText" @click="returnIndex" />
        <span>信息确认</span>
      </div>
    </van-sticky>
    <div class="content">
      <van-cell-group>
        <van-field label="卡号" v-model="formData.cardNo" type="number" />
        <van-field label="姓名" v-model="formData.customerName" />
        <div v-for="(item,index) in formData.orderList" :key="index" class="formList">
          <div>
            <div v-for="(img,index) in item.imageBase" :key="index" class="uploadShow">
              <img ref="showImg" id="showImg" :src="img" height="200"
                v-viewer="{fullscreen:false,backdrop:false,toggleOnDblclick:false,toolbar:false,navbar:false,inline:true,title:false,}" />
            </div>
            <div class="orderHeight" :style="{height:item.clentHeight+'px'}">
              <van-field label="订单编号" v-model="item.orderNo" @input="getFieldValue" />
              <van-field label="平台" value="大众点评" disabled />
              <van-field label="平台用户名" v-model="item.platName" @input="getFieldValue" />
              <div>
                <!-- <div v-if="item.bussinessChannel=='大众点评'"> -->
                <van-field label="券号" v-model="item.verificatioCode" @input="getFieldValue" />
                <van-field label="商品总价" v-model="item.allPrice" @input="getFieldValue" />
                <van-field label="商家立减" v-model="item.businessReduce" @input="getFieldValue" />
                <van-field label="平台立减" v-model="item.platformReduce" @input="getFieldValue" />
                <van-field label="平台抵用券" v-model="item.voucher" @input="getFieldValue" />
                <van-field label="优惠金额" v-model="item.discount" @input="getFieldValue" />
                <van-field label="订单总价" v-model="item.orderPrice" @input="getFieldValue" />
                <van-field label="实付款" v-model="item.actualPrice" @input="getFieldValue" />
                <van-field label="预定金" v-model="item.advancePayment" @input="getFieldValue" />
                <van-field label="尾款" v-model="item.balancePayment" @input="getFieldValue" />
              </div>
              <!-- <div v-if="item.bussinessChannel=='新氧'">
                <van-field label="预约码" v-model="item.cppointmentCode" @input="getFieldValue" />
                <van-field label="订单总金额" v-model="item.aa" @input="getFieldValue" />
                <van-field label="实付预约金" v-model="item.bb" @input="getFieldValue" />
                <van-field label="剩余应付(尾款)" v-model="item.cc" @input="getFieldValue" />
                <van-field label="本单实付金额" v-model="item.orderPrice" @input="getFieldValue" />
              </div> -->
              <div class="arrowLine">
                <van-field v-model="item.cardName" label="是否多次卡:" @click="handCard(index);showCard = true;" disabled />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="showCard" :actions="actionsCard" @select="onCard" />
              </div>
              <div class="arrowLine">
                <van-field v-model="item.areaName" label="平台院区:" @click="handArea(index);showArea = true;" disabled />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="showArea" :actions="actionsArea" @select="onArea" />
              </div>
              <div class="arrowLine">
                <van-field v-model="item.dsepartmentName" label="科室:" @click="handRoom(index);showRoom = true;"
                  disabled />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="showRoom" :actions="actionsRoom" @select="onRoom" />
              </div>
            </div>
          </div>
        </div>
      </van-cell-group>
    </div>
    <div class="submit" @click="submit()">提交</div>
  </div>
</template>
<script>
  import bus from '../../assets/js/bus';
  import {
    Dialog
  } from 'vant';
  import {
    importScanInfo,
  } from '@/axios/api'
  export default {
    name: 'textConfirmed',
    props: ['formList', 'formDataList'],
    data() {
      return {
        data: '',
        index: '',
        formData: {
          cardNo: '',
          customerName: '',
          orderList: []
        },
        showArea: false,
        showRoom: false,
        showCard: false,
        actionsArea: [{
          name: "伯思立",
          id: 'bsl',
        }, {
          name: "百达丽",
          id: 'bdl',
        }, {
          name: "翡丽思",
          id: 'fls',
        }, ],
        actionsRoom: [{
          name: "诊外",
          id: 'zw',
        }, {
          name: "皮肤科",
          id: 'pfk',
        }, {
          name: "注射科",
          id: 'zsk',
        }, ],
        actionsCard: [{
          name: "是",
          id: 1,
        }, {
          name: "否",
          id: 0,
        }],
        areaIndex: '',
        roomIndex: '',
        clentHeight: ''
      }
    },
    created() {
      bus.$on('listenToA', this.getAData);
    },
    methods: {
      getAData(val) {
        console.log('确认信息传过来的参数。。。')
        console.log(val)
        this.formData.orderList = val.orderList
        this.formData.cardNo = val.cardNo
        this.formData.customerName = val.customerName
        this.formData.orderList.forEach(ele => {
          console.log(ele.imageBase.length)
          if (ele.imageBase.length == 1) {
            console.log('只有一张图片')
            ele.clentHeight = window.screen.height - 330
            console.log(ele.clentHeight)
          } else if (ele.imageBase.length == 2) {
            console.log('两张图片')
            ele.clentHeight = window.screen.height - 500
            console.log(ele.clentHeight)
          } else if (ele.imageBase.length == 3) {
            console.log('三张图片')
            ele.clentHeight = window.screen.height - 670
            console.log(ele.clentHeight)
          }
        });
        this.$forceUpdate()
      },
      // 返回前一页
      returnIndex() {
        console.log('返回信息识别页面')
        this.formData = {
          cardNo: '',
          customerName: '',
          orderList: []
        }
        this.$emit('hideText', false);
        bus.$emit('listenToB', true);
      },
      //   提交参数
      submit() {
        console.log(this.formData)
        if (this.formData.cardNo == '' || this.formData.cardNo == undefined) {
          this.$toast.success('卡号不能为空！！！');
          return;
        }
        if (this.formData.customerName == '' || this.formData.customerName == undefined) {
          this.$toast.success('姓名不能为空！！！');
          return;
        }
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "努力加载中..."
        });
        let userId = JSON.parse(localStorage.getItem('userInfo')).empId
        var formData = new FormData();
        this.formData.orderList.forEach(ele => {
          ele.cardNo = this.formData.cardNo
          ele.customerName = this.formData.customerName
          ele.userId = userId
          ele.bussinessChannel = 1
        });
        formData.append("scanData", JSON.stringify(this.formData.orderList))
        importScanInfo(formData)
          .then((res) => {
            console.log(res.result);
            if (res.result == true) {
              this.$toast.clear();
              Dialog.alert({
                  message: '提交成功',
                  confirmButtonColor: '#108EE9'
                })
                .then(() => {
                  this.$emit('dialogVisibleEvent', false);
                  location.reload();
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              this.$toast.fail(res.errMsg);
              this.$toast.clear();
            }
          })
          .catch((err) => {
            console.log(err)
            this.$toast.clear();
          })
      },
      getFieldValue(e) {
        this.$forceUpdate()
      },
      onArea(item) {
        console.log(item)
        console.log(this.areaIndex)
        this.showArea = false;
        this.formData.orderList[this.areaIndex].areaCode = item.id
        this.formData.orderList[this.areaIndex].areaName = item.name
      },
      onRoom(item) {
        this.showRoom = false;
        this.formData.orderList[this.roomIndex].dsepartmentCode = item.id
        this.formData.orderList[this.roomIndex].dsepartmentName = item.name
      },
      onCard(item) {
        console.log(item)
        console.log(this.cardIndex)
        this.showCard = false;
        this.formData.orderList[this.cardIndex].isSecondary = item.id
        this.formData.orderList[this.cardIndex].cardName = item.name
      },
      handArea(index) {
        this.areaIndex = index
      },
      handRoom(index) {
        this.roomIndex = index
      },
      handCard(index) {
        this.cardIndex = index
      }
    }
  }

</script>
<style scoped>
  .uploadShow {
    width: 100%;
    height: 11rem;
    background: #EBF5FB;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    /* border: 1px solid red; */
  }

  .uploadShow img {
    opacity: 0;
  }

  .textHeader {
    height: 4rem;
    background: #fff;
    line-height: 4rem;
    display: flex;
    justify-content: center;
  }

  .vanIconText {
    position: absolute;
    left: 1rem;
    top: 1.5rem;
  }

  .textFoot {
    height: 5.4rem;
    background: #FFFFFF;
    /* border: 1px solid red; */
    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.28);
    border-radius: 2.5rem 2.5rem 0 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .textConfirmed {
    background: #F5F8F9;
    /* background: red; */
  }

  .continueButton {
    float: right;
    margin-right: 3%;
    margin-top: .5rem;
  }

  .textConfirmed>>>.van-cell-group {
    width: 94%;
    margin: 0 auto;
  }

  .formList {
    margin-top: .5rem;
    border: 1px solid #7AC7F4;
  }

  .submit {
    width: 80%;
    margin: 1rem 0 1rem 10%;
    height: 2.875rem;
    line-height: 2.875rem;
    text-align: center;
    font-size: 0.875rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    background: linear-gradient(122deg, #17BCC5 0%, #0164A8 100%);
    border-radius: 2rem;
  }

  .textConfirmed>>>.van-field--disabled .van-field__label {
    color: #323233 !important;
  }

  .textConfirmed>>>.van-field__control:disabled {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  .arrowLine {
    display: flex;
    align-items: center;
  }

  .arrowLine>>>.van-icon-arrow::before {
    margin-right: .5rem;
  }

  .textConfirmed>>>.van-field__label {
    width: 7.2em !important;
  }

  .orderHeight {
    overflow: scroll;
  }

</style>



// WEBPACK FOOTER //
// src/components/textUpload/textConfirmed.vue